import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

/**
 * Devuelve únicamente los horarios ocupados del grupo derivado por backend.
 * No expone el feed de subastas a quien sólo posee `auctions.create`.
 */
export const getAuctionScheduleForGroup = async ({
  operatingUnitId,
  dealershipId,
} = {}) => {
  if (!operatingUnitId && !dealershipId) {
    return { success: 'no', data: [], message: 'El contexto operativo es requerido' };
  }
  try {
    const fn = httpsCallable(functions, 'getAuctionScheduleForGroupV2');
    const result = await fn({
      operatingUnitId,
      dealershipId,
      requestedApp: 'dealership_web',
    });
    return result.data;
  } catch (error) {
    console.error('Error obteniendo horarios de subastas:', error);
    notifyPermissionDenied(error);
    return { success: 'no', data: [], message: error.message };
  }
};
